import React from 'react';
import { Loader2Icon } from 'lucide-react';
type Variant = 'primary' | 'secondary' | 'tertiary' | 'ghost';
type Size = 'sm' | 'md' | 'lg';
type ButtonProps = {
  children: React.ReactNode;
  variant?: Variant;
  size?: Size;
  onDark?: boolean;
  loading?: boolean;
  className?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;
const sizes: Record<Size, string> = {
  sm: 'h-9 px-3.5 text-sm gap-1.5',
  md: 'h-11 px-5 text-[15px] gap-2',
  lg: 'h-[52px] px-7 text-base gap-2'
};
function variantClasses(variant: Variant, onDark: boolean): string {
  switch (variant) {
    case 'primary':
      return 'bg-green-600 text-white hover:bg-green-700 active:bg-green-800 shadow-sm disabled:bg-slate-500/40 disabled:text-white/70';
    case 'secondary':
      return onDark ? 'border border-white/35 text-white hover:bg-white/10 active:bg-white/15 disabled:opacity-45' : 'border border-ink/20 text-ink hover:border-ink/40 hover:bg-ink/[0.04] active:bg-ink/[0.07] disabled:opacity-45';
    case 'tertiary':
      return onDark ? 'text-gold-300 hover:text-gold-100 px-0 h-auto' : 'text-green-700 hover:text-green-800 px-0 h-auto';
    default:
      return onDark ? 'text-white/80 hover:text-white' : 'text-slate-600 hover:text-ink';
  }
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  onDark = false,
  loading = false,
  className = '',
  disabled,
  ...rest
}: ButtonProps) {
  const base = 'inline-flex items-center justify-center rounded-lg font-sans font-semibold tracking-[-0.01em] transition-[background-color,border-color,color,transform,box-shadow] duration-150 ease-emphasis disabled:cursor-not-allowed whitespace-nowrap';
  return <button type="button" disabled={disabled || loading} className={`${base} ${variant === 'tertiary' ? 'gap-2 text-[15px]' : sizes[size]} ${variantClasses(variant, onDark)} ${className}`} {...rest} data-id="element-575" data-mp="17e1xqduxilkf">
      {loading && <Loader2Icon aria-hidden className="h-4 w-4 animate-spin" data-id="element-576" data-mp="1ofpnha5c3t10" />}
      {children}
    </button>;
}